import {
  SnackbarProvider,
  closeSnackbar,
  MaterialDesignContent,
} from 'notistack';
import React, { useEffect, useRef } from 'react';
import { styled } from '@mui/material/styles';

import NotificationActionButtons from './NotificationActionButtons';
import NotificationHandler from './NotificationHandler';

// import styles from './snackBarProviderStyle';
import injectStores from '../RootStore/injectStores';
import NotificationStore from 'stores/NotificationStore';

interface NotificationProviderProps {
  notificationStore?: NotificationStore;
  children: React.ReactNode;
}

const StyledMaterialDesignContent = styled(MaterialDesignContent)(
  ({ theme }) => ({
    '&.notistack-MuiContent-success': {
      backgroundColor: theme.palette.success.main,
    },
    '&.notistack-MuiContent-error': {
      backgroundColor: theme.palette.error.main,
    },

    '&.notistack-MuiContent-warning': {
      backgroundColor: theme.palette.warning.main,
    },

    '&.notistack-MuiContent-info': {
      backgroundColor: theme.palette.info.main,
    },
  })
);

const NotificationProvider = injectStores(
  ({ notificationStore, children }: NotificationProviderProps) => {
    const myRef = useRef<SnackbarProvider>(null);

    const onClickDismiss = (key: string | number) => {
      closeSnackbar(key);
    };

    useEffect(() => {
      notificationStore.setRef(myRef);
    }, [notificationStore, myRef]);

    return (
      <>
        <SnackbarProvider
          ref={myRef}
          action={(key) => (
            <NotificationActionButtons
              dismissNotification={() => onClickDismiss(key)}
              close
            />
          )}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          preventDuplicate
          maxSnack={4}
          Components={{
            success: StyledMaterialDesignContent,
            error: StyledMaterialDesignContent,
          }}
        />
        {children}
        <NotificationHandler />
      </>
    );
  }
);

export default NotificationProvider;
